export default class Globals {
	url_base_solicitudes: string;
	host_local: string;
	dev_mode: string;
	expire: number;
	idEmpresa: string;
	usuario: string;
	token: string;
	token_type: string;
	authtoken: string = '';
	authtoken_type: string = '';
	urlRecursosEmpresa: string;
	base_url: string;
}
